/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TChatsBulkOperationsReadAllFromSectionDesktopModel = IModel<
  IChatsBulkOperationsReadAllFromSectionDesktopRequest,
  TChatsBulkOperationsReadAllFromSectionDesktopResponse
>;

export interface IChatsBulkOperationsReadAllFromSectionDesktopRequest {
  section: ESection;
}

export type TChatsBulkOperationsReadAllFromSectionDesktopResponse =
  | IChatsBulkOperationsReadAllFromSectionDesktopResponse200
  | IChatsBulkOperationsReadAllFromSectionDesktopResponse400;

export interface IChatsBulkOperationsReadAllFromSectionDesktopResponse200
  extends IModelResponse<IChatsBulkOperationsReadAllFromSectionDesktopResponse> {
  statusCode: 200;
}

export interface IChatsBulkOperationsReadAllFromSectionDesktopResponse400
  extends IModelResponse<IChatsBulkOperationsReadAllFromSectionDesktopResponseError> {
  statusCode: 400;
}

export interface IChatsBulkOperationsReadAllFromSectionDesktopResponse {}

export interface IChatsBulkOperationsReadAllFromSectionDesktopResponseError {
  errors: any[];
  message: string;
}

export type TResponses =
  | IChatsBulkOperationsReadAllFromSectionDesktopResponse
  | IChatsBulkOperationsReadAllFromSectionDesktopResponseError;

export enum ESection {
  /** Раздел "Архив" **/
  Archive = 'archive',
  /** Раздел "Сообщения" **/
  Main = 'main',
  /** Раздел "Непрочитанные" **/
  Unread = 'unread',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IChatsBulkOperationsReadAllFromSectionDesktopResponse): TResponse200;
  400(response: IChatsBulkOperationsReadAllFromSectionDesktopResponseError): TResponse400;
}
